export default __webpack_public_path__ + "static/media/Larsseit-Medium.7b432d65.ttf";